import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Title from '../../../components/Title';
import { StoreCategory, StoreProductVersion } from '../../../types/store';
import { getFilteredStores } from '../../../store/selectors/storesSelectors';
import { routePaths } from '../../../router/paths';
import { currentLang } from '../../../../../utils/lang';
import { useGetResellersQuery } from '../../../store/services/resellers';
const Maintenance = () => {
    const { t } = useTranslation();
    const currentLocale = currentLang();
    const stores = useSelector(getFilteredStores);
    const { data: resellers } = useGetResellersQuery('');
    const resellersWithPins = useMemo(() => {
        if (!resellers) {
            return null;
        }
        return resellers.filter(reseller => stores.some(store => store.replacementProductVersions?.length && reseller.name === store.reseller?.name));
    }, [stores, resellers]);
    const swapProductVersionsString = useMemo(() => {
        if (!resellersWithPins) {
            return null;
        }
        return [
            StoreProductVersion.Version3,
            StoreProductVersion.Version3Duo,
            StoreProductVersion.VersionOriginals,
            StoreProductVersion.Version3Multi,
            StoreProductVersion.Version24,
            StoreProductVersion.Version24Plus,
            StoreProductVersion.VersionIlumaPrime,
            StoreProductVersion.VersionIluma,
            StoreProductVersion.VersionIlumaOne,
            StoreProductVersion.VersionIlumaIPrime,
            StoreProductVersion.VersionIlumaI,
            StoreProductVersion.VersionIlumaIOne,
        ]
            .filter(productVersion => stores.some(store => store.category !== StoreCategory.Iqos &&
            store.replacementProductVersions &&
            store.replacementProductVersions.indexOf(productVersion) !== -1 &&
            store.reseller &&
            resellersWithPins.find(reseller => reseller.name === store.reseller?.name)))
            .map(version => t(`store_locator.product_versions.${version}`))
            .join(', ');
    }, [stores, resellersWithPins]);
    return (_jsxs("div", { children: [_jsx(Title, { title: t('store_locator.maintenance.title'), viewInMap: true }), _jsxs("div", { className: "list-group list-group-padless mb-4", children: [_jsx("a", { href: t('store_locator.maintenance.register_issue_link'), className: "list-group-item list-group-item-action", children: t('store_locator.maintenance.register_issue') }), _jsx(Link, { to: routePaths.IqosStores[currentLocale], className: "list-group-item list-group-item-action list-group-item-arrowed-right", children: t('store_locator.maintenance.visit_brand_stores') })] }), resellersWithPins && swapProductVersionsString && resellersWithPins.length && (_jsxs(_Fragment, { children: [_jsx("h2", { className: "font-size-extra-large", children: t('store_locator.maintenance.resellers.title') }), _jsx("p", { className: "font-size-small mb-4", children: parse(t('store_locator.maintenance.resellers.description', {
                            products: swapProductVersionsString,
                        })) }), _jsx("div", { className: "list-group list-group-padless mb-4", children: resellersWithPins.map(reseller => {
                            return (_jsx(Link, { to: routePaths.ResellerStores[currentLocale].replace(':reseller', reseller.slug), className: "list-group-item list-group-item-action list-group-item-arrowed-right", children: reseller.name }, reseller.id));
                        }) })] }))] }));
};
export default Maintenance;
